import React from 'react';
import './About.css';

function About() {
	return (
		<div className='about-container'>
			<h5 className='words'>
				Ever since my childhood, I have been in love with video games. The
				ability to experience the lore of a story or to engage with other people
				around the world has always appealed to me. Below are examples of the
				games I made while as a student at Adelphi University.
			</h5>
		</div>
	);
}

export default About;
